export default __webpack_public_path__ + "static/media/nuri.66942c88.jpg";